import { createSlice } from "@reduxjs/toolkit";
import { ListResearchReport } from "core/http/service/researchReport/resTypes";
import { ReduxStateType } from "redux-store/types";
interface InitialState {
  data: ListResearchReport[];
  status: ReduxStateType;
}
const initialState: InitialState = {
  data: [],
  status: ReduxStateType.INIT,
};

const getListResearchReportSlice = createSlice({
  name: "getListResearchReportSlice",
  initialState,
  reducers: {
    getListResearchReportStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getListResearchReportSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = [...state.data, ...action.payload.data];
    },
    getListResearchReportFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = [];
    },
    resetGetListResearchReport: (state) => initialState,
  },
});

export const {
  getListResearchReportStart,
  getListResearchReportSuccess,
  getListResearchReportFailed,
  resetGetListResearchReport,
} = getListResearchReportSlice.actions;

export default getListResearchReportSlice.reducer;
